export enum DateRange {
    Today = 0,
    Yesterday = 1,
    Week = 2,
    Last30Days = 3,
    Custom = 4,
    ThisWeek = 5,
    LastWeek = 6,
    Latest3Weeks = 7,
    ThisMonth = 8,
    LastMonth = 9,

    /*
     * Last 14 days exclusive of today (i.e. ends yesterday)
     */
    Last14Days = 10,
    Last7Days = 11,

    /*
     * Last 14 days inclusive of today
     */
    Latest14Days = 12,
    Latest7Days = 13,
    Latest4Weeks = 14
}
